{
  "messages": {
    "networkError": "Ocorreu um erro de rede. Se o problema persistir, entre em contato conosco.",
    "appointmentUpdatedValidationFailed": "O agendamento foi atualizado, mas falhou na validação externa.",
    "appointmentCreatedValidationFailed": "O agendamento foi criado, mas falhou na validação externa.",
    "validationErrorDetail": "<br /> Erro de validação: {error}"
  },
  "titles": {
    "warehouseRuleFailed": "Falha na regra do armazém",
    "validationServerError": "Erro do servidor de validação",
    "appointmentUpdatedWithValidationError": "Agendamento atualizado com erro de validação",
    "appointmentCreatedWithValidationError": "Agendamento criado com erro de validação"
  }
}
